export function RecipeCard ({ recipe, name, ingredients, setReading, setReadRecipe }) {
  const HandleClickRead = () => {
    setReading(true)
    setReadRecipe(name)
  }

  return (
    <div className={recipe === 1 ? 'rounded-2xl bg-[#353535] w-full p-4 max-[480px]:mx-auto max-[480px]:w-4/5' : 'rounded-2xl bg-[#353535] w-full p-4 max-[480px]:mx-auto max-[480px]:w-4/5'}>
              <h5 className={recipe === 1 ? 'text-[#f34d00da] text-2xl font-semibold' : 'text-2xl font-semibold'}>{name}</h5>
              <p className='mt-4 mb-2'>Ingredientes necesarios:</p>
              <div className='text-sm bg-[#313131] p-2 rounded-lg overflow-auto max-h-28 scrollbar-thin scrollbar-thumb-[#f34e00] hover:scrollbar-thumb-[#f34d00da] active:scrollbar-thumb-sky-300 scrollbar-track-slate-900 '>
                {ingredients.map((item) => (
                  <p className={item.clock === 1 ? 'text-[#f34d00da]' : ''} key={item.name}>{item.mount} {item.form} - {item.name}</p>
                ))}
              </div>
              <div className='w-full flex justify-center mt-2'>
                <button onClick={HandleClickRead} className='bg-[#f34d00da] p-1 px-2 rounded-xl'>Leer</button>
              </div>
            </div>
  )
}
